module.exports = __webpack_public_path__ + "img/appAsset-brand--Prepago.8a1631eb.svg";